import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 97 97">
    <title>Logo</title>
    <polygon
      id="Shape"
      stroke="currentColor"
      strokeWidth="5px"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="2.9 47.5 24.9 86.5 69.9 86.5 92.9 47.5 70.9 8.5 25.9 8.5 2.9 47.5"
    />
    <path
      d="M36.1,63.8h-3.7l-8.4-21.4v21.4h-5v-30.7h6l9.4,23.6,9.2-23.6h5.8v30.7h-5v-21.4l-8.2,21.4Z"
      fill="currentColor"
    />
    <path
      d="M56,59.8c-2.7-3-4-6.8-4-11.4s1.3-8.5,4-11.4c2.6-3,6-4.4,10-4.4s6.2.9,8.3,2.7c2.2,1.8,3.6,4.3,4.2,7.4h-5.1c-1.3-3.6-3.8-5.5-7.4-5.5s-4.8,1-6.3,3.1c-1.6,2.1-2.4,4.8-2.4,8s.8,5.9,2.4,8c1.6,2.1,3.7,3.1,6.3,3.1s6.1-1.8,7.4-5.5h5.1c-.6,3.2-2,5.7-4.2,7.5-2.2,1.8-4.9,2.7-8.3,2.7s-7.3-1.5-10-4.4Z"
      fill="currentColor"
    />
  </svg>
);

export default IconLogo;
